// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_jla","cls2":"FilterPanel-cls2_6Bj FilterPanel-cls1_jla"};